import { createContext, useContext } from 'react';

export const BillingTransactionContext = createContext();

export const useBillingTransactionContext = () =>
  useContext(BillingTransactionContext);

export default BillingTransactionContext;
